import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { resolveImg } from "@/lib/media";

export default function VehicleCard({ vehicle, index = 0 }) {
  const price = new Intl.NumberFormat("en-GH", { style: "currency", currency: "GHS", maximumFractionDigits: 0 }).format(vehicle.price_ghs);
  const typeLabel =
    vehicle.type === "ev" ? "Electric" :
    vehicle.type === "hybrid" ? "Plug-in Hybrid" :
    vehicle.type === "commercial" ? "Commercial" : "Petrol";

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1], delay: (index % 3) * 0.1 }}
      className="group"
      data-testid={`vehicle-card-${vehicle.slug}`}
    >
      <Link to={`/vehicle/${vehicle.slug}`} className="block">
        {/* Editorial image frame */}
        <div className="vehicle-frame">
          <img src={resolveImg(vehicle.images[0])} alt={`${vehicle.make} ${vehicle.model}`} loading="lazy" />
          <div className="absolute top-5 left-5 z-10 flex items-center gap-3">
            <span className="w-6 h-px bg-[#C5A059]" />
            <span className="text-[10px] tracking-[0.28em] uppercase text-[#C5A059]">
              {typeLabel}
            </span>
          </div>
          {vehicle.featured && (
            <div className="absolute top-5 right-5 z-10 px-3 py-1 text-[9px] tracking-[0.24em] uppercase bg-[#C5A059] text-[#050814]">
              Featured
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-[#050814]/60 via-transparent to-transparent" />
        </div>

        {/* Editorial caption */}
        <div className="mt-8 flex items-baseline justify-between gap-6">
          <div>
            <div className="text-[10px] tracking-[0.28em] uppercase text-white/40 mb-3">
              {vehicle.year} · {vehicle.make}
            </div>
            <div className="font-display text-3xl md:text-4xl leading-[1.05] group-hover:text-[#C5A059] transition-colors duration-700">
              {vehicle.model}
            </div>
          </div>
          <ArrowUpRight
            size={18}
            className="text-white/45 group-hover:text-[#C5A059] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-700 mt-2 shrink-0"
          />
        </div>

        <div className="w-10 h-px bg-white/15 my-6" />

        <div className="flex items-baseline justify-between text-sm">
          <div className="text-white/55 space-x-3 text-xs tracking-wide">
            <span>{vehicle.mileage_km.toLocaleString()} km</span>
            <span className="text-white/25">·</span>
            <span>{vehicle.engine}</span>
          </div>
          <div className="font-display text-lg md:text-xl text-white">{price}</div>
        </div>
      </Link>
    </motion.div>
  );
}
